import { SET_COMBINATIONS } from '../actions/mixedProductActions';

const initialState = {
  combinations: [],
};

const mixedProductreducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMBINATIONS:
      return { ...state, combinations: action.payload };
    default:
      return state;
  }
};

export default mixedProductreducer;
